/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "@/api/Helper";

export const createTelegramChannel = async (
  chatbotId: string,
  botToken: string
): Promise<string> => {
  const response = await fetchCloudRun(
    "http://localhost:8080/api/bot/chatbots/" +
      chatbotId +
      "/channels/telegram",
    "POST",
    {},
    {
      bot_token: botToken,
    }
  );
  return response.id;
};
